export const getFixedHeaderClass = (collapsed) =>
  `fixed z-[20] top-0 transition-all duration-300 ease-in-out ${
    collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
  }`;

export const getFixedSubHeaderClass = (collapsed) =>
  `fixed z-[20] top-[4rem] transition-all duration-300 ease-in-out ${
    collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
  }`;
